import { useState } from 'react';
import { apiService } from '../../../client/common/apiCallService';
import { useSelector } from 'react-redux';
import { useJunoCommonFunctions } from '../../../client/Juno/helpers';

const useDeleteStatements = () => {
    const [selectedStatement, setSelectedStatement] = useState(null);
    const apiUrl = useSelector(state => state.config.api_url);
    const { getStatements } = useJunoCommonFunctions();

    const deleteStatement = (id, cleanUp) => {
        apiService(
            (window.location.hostname === 'localhost' ? apiUrl : '') +
                `/restapi/delete/statements/${id}`,
            {},
            () => {
                getStatements();
                setSelectedStatement(null);
                if (cleanUp) cleanUp();
            },
            err => {
                console.log(err);
                setSelectedStatement(null);
            },
        );
    };

    return [selectedStatement, setSelectedStatement, deleteStatement];
};

export default useDeleteStatements;
